import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { isEmpty, pick } from 'ramda';

import { getGame } from 'js/components/common/Game';
import { Redirect } from 'js/components/common/Redirect';

import { closeGameInfoPopup, showGameInfoPopup } from 'js/app/components/popups/GamesInfoPopup/actions';
import { useAppSelector } from 'js/store/hooks';

/* copied in core, added isEmpty(line 21) and destroyed effect(line 37) */
export const GamesInfoPopupLauncher = ({ onClose }) => {
    const { gamesConfiguration, rootPage } = useAppSelector(pick(['gamesConfiguration', 'rootPage']));
    const dispatch = useDispatch();
    const [notFound, setNotFound] = useState(false);
    const history = useHistory();
    const { gameCode } = useParams();

    useEffect(() => {
        if (isEmpty(gamesConfiguration)) {
            return;
        }

        const game = getGame(gameCode)(gamesConfiguration);

        if (isEmpty(game)) {
            setNotFound(true);
            return;
        }

        // TODO: (CORE) todo should be refactored after fix history navigation
        const navigationDirection = 1;

        dispatch(showGameInfoPopup({ gameCode, navigationDirection, onClose }));

        return () => dispatch(closeGameInfoPopup());
    }, [gamesConfiguration, gameCode, dispatch, history, onClose]);

    if (notFound) {
        return <Redirect to={rootPage} />;
    }

    return null;
};
